import { render, staticRenderFns } from "./cate-modal.vue?vue&type=template&id=5493e274&"
import script from "./cate-modal.vue?vue&type=script&lang=js&"
export * from "./cate-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports